import { useRouteMatch } from 'react-router';

import { MirrorInvoice } from 'pages/Private/Invoices/MirrorInvoice';

import { Route } from '../Route';

export const InvoicesRoutes = () => {
  const { url } = useRouteMatch();

  return (
    <>
      <Route isPrivate path={`${url}/mirror-invoice`} component={MirrorInvoice} />
    </>
  );
};
